const my_profile = {
  viewMyClubSeacretProfile: "查看我的 ClubSecret 个人资料", // translated
  viewMoreDetails: "查看更多详情", // translated
  verifiedEmail: "已验证的电子邮件", // translated
  unverifiedEmail: "未经验证的电子邮件", // translated
  pointsIn: "点入", // translated
  balance: "平衡", // translated
  pointsOut: "指出", // translated
  pointsHistoryTable: "积分历史表", // translated
  topUp: "充值", // translated
  createdFrom: "创建自", // translated
  createdTo: "创建至", // translated
  selectStatus: "选择状态...", // translated
  searchByTitle: "按标题搜索...", // translated
  offerStatus: "报价状态", // translated
  selectOfferStatus: "全部", // translated
  quotationSent: "报价已发送", // translated
  offerInProgress: "报价进行中", // translated
  offerAvailable: "报价可用", // translated
  offerAccepted: "报价已接受", // translated
  offerExpired: "报价已过期", // translated
  offerReference: "报价参考号", // translated
  tripStartDate: "行程开始日期", // translated
  dueDate: "截止日期", // translated
  viewOffer: "查看报价", // translated
  notApplicable: "不适用", // translated
  manageSubscription: "管理订阅", // translated
  logoAndColors: "标志与颜色", // translated
  editColors: "编辑颜色", // translated
  editLogo: "编辑标志", // translated
  primaryColor: "主色", // translated
  secondaryColor: "辅色", // translated
  subagentLogoAlt: "子代理标志", // translated
  pickColors: "选择颜色", // translated
  logoPreview: "标志预览", // translated
  logoPreviewAlt: "标志预览", // translated
  noLogoSelected: "未选择标志", // translated
  changeLogo: "更换标志", // translated
  uploadLogo: "上传标志", // translated
  supportedImageFormats: "支持格式：JPG、PNG。最大大小：2MB", // translated
  saving: "正在保存...", // translated
  logoUpdatedSuccess: "标志更新成功", // translated
  failedToUpdateLogo: "标志更新失败", // translated
  colorsUpdatedSuccess: "颜色更新成功", // translated
  failedToUpdateColors: "颜色更新失败", // translated
  selectImageFile: "请选择图片文件", // translated
  imageSizeLimit: "图片大小必须小于 5MB", // translated
  pushNotifications: "群众通知", // translated 
  pushNotificationsDescription: "接收浏览器通知以获取重要更新和事件", // translated 
  pushNotificationsNotSupported: "此浏览器不支持大众通知", // translated 
  pushNotificationsDeniedMessage: "通知权限被拒绝。请在浏览器设置中启用通知以接收主动通知。", // translated 
  pushNotificationsEnabled: "积极通知已成功启用", // translated 
  pushNotificationsDisabled: "集体通知已成功取消", // translated 
  userInformationMissing: "缺少用户信息", // translated 
  failedToUpdatePushNotifications: "无法更新主动通知设置", // translated 
  notificationPermissionDenied: "通知权限被拒绝。请在浏览器设置中启用它。", // translated 
  notificationPermissionRequired: "需要通知权限才能激活全民通知", // translated 
  notSupported: "不支持", // translated 
  permissionDenied: "权限被拒绝", // translated 
  permissionNotRequested: "未请求权限", // translated 
  enabled: "已启用", // translated 
  disabled: "已取消", // translated 
};


export default my_profile;
